<div class="map"
     leaflet
     [leafletOptions]="options"
     (leafletMapReady)="mapReady($event)"
     [leafletLayers]="layers"
     (leafletClick)="leafletClick($event)"
     (leafletMapMoveStart)="leafletMapMoveStart($event)"
     (leafletMapMoveEnd)="leafletMapMoveEnd($event)">
      
  <button class="map-button blueBtn detail-button" (click)="onDetailClick($event)">Detail</button>
  <button class="map-button blueBtn location-button" (click)="onLocationClick($event)">
    @if(!locationEnabled)
    {
    {{'Moje poloha' | translate}}
    }
    @else
    {
    {{'Skrýt moji polohu' | translate}}
    }
  </button>
</div>
